module.exports = __webpack_public_path__ + "static/media/7-Diamond.37eae8b5.svg";